import React from "react";

const News = () => {
  return (
    <div className="min-h-screen flex flex-col items-center bg-white py-12 px-4 sm:px-6 lg:px-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-2">Fyled AI News</h1>
      <p className="mb-8 text-gray-700 text-center max-w-xl">
        Stay updated with our latest news and updates directly from our LinkedIn
        page.
      </p>
      <div className="w-full max-w-5xl grid grid-rows-1 grid-cols-3 gap-8 mb-8">
        <div className="bg-white border rounded-lg shadow-lg flex flex-col items-center p-4 w-full h-full" tabIndex={0} aria-label="LinkedIn post 1">
          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:share:7343700046875344897?collapsed=1"
            height="265"
            width="100%"
            title="Embedded post 1"
            className="border rounded-lg shadow-lg w-full"
            aria-label="Embedded post 1"
          ></iframe>
        </div>
        <div className="bg-white border rounded-lg shadow-lg flex flex-col items-center p-4 w-full h-full" tabIndex={0} aria-label="LinkedIn post 2">
          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:share:7343705139783880705?collapsed=1"
            height="265"
            width="100%"
            title="Embedded post 2"
            className="border rounded-lg shadow-lg w-full"
            aria-label="Embedded post 2"
          ></iframe>
        </div>
        <div className="bg-white border rounded-lg shadow-lg flex flex-col items-center p-4 w-full h-full" tabIndex={0} aria-label="LinkedIn post 3">
          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:share:7343707404775079938?collapsed=1"
            height="265"
            width="100%"
            title="Embedded post 3"
            className="border rounded-lg shadow-lg w-full"
            aria-label="Embedded post 3"
          ></iframe>
        </div>
      </div>
      <a
        href="https://www.linkedin.com/company/fyled-ai/posts/"
        target="_blank"
        rel="noopener noreferrer"
        className="mt-4 inline-block px-6 py-2 bg-blue-700 text-white rounded hover:bg-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        aria-label="View all LinkedIn posts"
        tabIndex={0}
      >
        View All LinkedIn Posts
      </a>
    </div>
  );
};

export default News;
